"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M23.005 10.023c0 .6-.49 1.09-1.092 1.09H2.087a1.091 1.091 0 0 1-1.091-1.09V6.85c0-.601.489-1.09 1.09-1.09h8.162c-.847.443-1.766.97-2.298 1.428a.495.495 0 1 0 .645.752c.753-.645 2.486-1.51 3.404-1.945.92.436 2.652 1.299 3.405 1.945a.495.495 0 1 0 .645-.752c-.53-.457-1.448-.985-2.296-1.428h8.16c.602 0 1.091.489 1.091 1.09v3.173Zm-2.38 11.896c0 .6-.49 1.088-1.091 1.088H3.672a1.09 1.09 0 0 1-1.091-1.088v-9.815h18.043v9.815ZM7.75 3.486c-.601-.601-.601-1.473 0-2.075A1.44 1.44 0 0 1 8.777.99h.03a1.49 1.49 0 0 1 1.018.42c.393.393.853 1.93 1.14 3.216-1.284-.288-2.821-.748-3.214-1.141Zm6.423-2.075c.503-.501 1.456-.62 2.076 0 .6.602.6 1.474 0 2.075-.393.393-1.931.853-3.216 1.14.287-1.284.746-2.822 1.14-3.215Zm7.739 3.358h-5.917c.403-.176.742-.371.954-.582.992-.991.99-2.486 0-3.477-.938-.941-2.532-.943-3.476 0-.72.72-1.255 2.95-1.475 4.004C11.78 3.66 11.245 1.43 10.525.71A2.489 2.489 0 0 0 8.827 0C8.184.007 7.52.239 7.05.71c-.991.99-.991 2.486 0 3.477.21.21.55.406.954.582H2.087a2.084 2.084 0 0 0-2.082 2.08v3.174c0 .976.677 1.799 1.586 2.021v9.875c0 1.148.934 2.081 2.082 2.081h15.86a2.084 2.084 0 0 0 2.082-2.081v-9.815h.298a2.085 2.085 0 0 0 2.082-2.081V6.85a2.084 2.084 0 0 0-2.082-2.081Z",
    clipRule: "evenodd"
  })]
});